<template>
	<div v-if="visible" class="detail-overlay" @click.self="handleClose">
		<div class="detail-container">
			<!-- 关闭按钮 -->
			<button class="close-btn" @click="handleClose">
				<i class="el-icon-close"></i>
			</button>
			
		<!-- 产品头部 -->
		<div class="detail-header">
			<div class="header-icon-wrapper">
				<img :src="product.logo || defaultImage" @error="handleImageError($event)" class="header-icon-img" />
			</div>
			<div class="header-info">
				<h2 class="product-title">{{ product.name }}</h2>
				<div class="product-stats">
					<div class="stat-item">
						<div class="stat-label">{{ $t('Financial.subscriptionPrice') || '认购价格' }}</div>
						<div class="stat-value">${{ product.min }} - ${{ product.max }}</div>
					</div>
					<div class="stat-item">
						<div class="stat-label">{{ $t('Financial.yieldRate') || '收益率' }}</div>
						<div class="stat-value rate">{{ product.rate }}%</div>
					</div>
				</div>
			</div>
		</div>
			
			<!-- 产品信息 -->
			<div class="info-grid">
				<div class="grid-item">
					<div class="grid-label">{{ $t('Financial.duration') || '投资期限' }}</div>
					<div class="grid-value">{{ product.days }} {{ $t('Financial.days') || '天' }}</div>
				</div>
			<div class="grid-item">
				<div class="grid-label">{{ $t('Financial.type') || '产品类型' }}</div>
				<div class="grid-value">{{ product.name }}</div>
			</div>
			</div>
			
			<!-- 产品描述 -->
			<div class="description-section">
				<h3 class="section-title">{{ $t('Financial.description') || '产品描述' }}</h3>
				<p class="description-text">{{ $t('Financial.descriptionText') || '这是一个智能理财产品，通过算法自动交易，为您提供稳定的收益。' }}</p>
			</div>
			
			<!-- 购买金额输入 -->
			<div class="amount-section">
				<h3 class="section-title">{{ $t('Financial.purchaseAmount') || '购买金额' }}</h3>
				<div class="amount-input-wrapper">
					<span class="currency-symbol">$</span>
					<input 
						v-model="amount"
						type="number" 
						class="amount-input"
						:placeholder="$t('Financial.enterAmount') || '请输入购买金额'"
						@input="validateAmount"
					>
					<button class="max-btn" @click="setMaxAmount">
						{{ $t('Financial.max') || '最大' }}
					</button>
				</div>
				<div class="amount-range">
					<span>{{ $t('Financial.minAmount') || '最小' }}: ${{ product.min }}</span>
					<span>{{ $t('Financial.maxAmount') || '最大' }}: ${{ product.max }}</span>
				</div>
				<div v-if="errorMessage" class="error-message">{{ errorMessage }}</div>
			</div>
			
		<!-- 操作按钮 -->
		<div class="action-buttons">
			<button class="buy-btn" @click="handlePurchase" :disabled="isDisabled">
				{{ $t('Financial.buyNow') || '立即购买' }}
			</button>
			<button class="cancel-btn" @click="handleClose">
				{{ $t('common.cancel') || '取消' }}
			</button>
		</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'FinancialDetail',
	props: {
		visible: {
			type: Boolean,
			default: false
		},
		product: {
			type: Object,
			default: () => ({})
		},
		userBalance: {
			type: Number,
			default: 0
		}
	},
	data() {
		return {
			amount: '',
			errorMessage: '',
			defaultImage: 'data:image/png;base64,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'
		};
	},
	computed: {
		isDisabled() {
			// 如果没有输入金额，禁用按钮
			if (!this.amount || this.amount.trim() === '') {
				return true;
			}
			// 如果有错误消息，禁用按钮
			if (this.errorMessage && this.errorMessage.trim() !== '') {
				return true;
			}
			return false;
		}
	},
	watch: {
		visible(newVal) {
			if (newVal) {
				// 弹窗打开时，清空之前的输入
				this.amount = '';
				this.errorMessage = '';
				// 调试信息
				console.log('💰 理财产品详情:', this.product);
				console.log('💵 用户余额:', this.userBalance);
			}
		},
		amount(newVal) {
			console.log('📝 输入金额:', newVal);
			console.log('❌ 错误消息:', this.errorMessage);
			console.log('🔒 按钮禁用:', this.isDisabled);
		}
	},
	methods: {
		handleClose() {
			this.amount = '';
			this.errorMessage = '';
			this.$emit('update:visible', false);
			this.$emit('close');
		},
		
		setMaxAmount() {
			const maxAmount = Math.min(this.product.max, this.userBalance);
			this.amount = maxAmount.toString();
			this.validateAmount();
		},
		
		validateAmount() {
			const num = parseFloat(this.amount);
			
			if (!this.amount || this.amount.trim() === '') {
				this.errorMessage = '';
				return;
			}
			
			if (isNaN(num) || num <= 0) {
				this.errorMessage = this.$t('Financial.errorInvalid') || '请输入有效的金额';
				return;
			}
			
			if (num < this.product.min) {
				this.errorMessage = (this.$t('Financial.errorMinAmount') || '购买金额不能小于 ${min}').replace('${min}', '$' + this.product.min);
				return;
			}
			
			if (num > this.product.max) {
				this.errorMessage = (this.$t('Financial.errorMaxAmount') || '购买金额不能大于 ${max}').replace('${max}', '$' + this.product.max);
				return;
			}
			
			if (num > this.userBalance) {
				this.errorMessage = this.$t('Financial.errorInsufficientBalance') || '余额不足';
				return;
			}
			
			this.errorMessage = '';
		},
		
	handlePurchase() {
		this.validateAmount();
		
		if (this.errorMessage) {
			return;
		}
		
		this.$emit('purchase', {
			product: this.product,
			amount: parseFloat(this.amount)
		});
		
		this.handleClose();
	},
	
	// 图片加载失败时使用默认图片
	handleImageError(event) {
		event.target.src = this.defaultImage;
	}
	}
};
</script>

<style scoped>
/* 遮罩层 */
.detail-overlay {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: var(--modal-overlay-bg, rgba(0, 0, 0, 0.6));
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 10000;
	transition: all 0.3s ease;
}

/* 容器 */
.detail-container {
	width: 600px;
	max-width: 95vw;
	max-height: 90vh;
	background: var(--card-bg, #ffffff);
	border-radius: 16px;
	box-shadow: var(--modal-shadow, 0 8px 32px rgba(0, 0, 0, 0.15));
	overflow-y: auto;
	position: relative;
	padding: 40px;
	transition: background-color 0.3s ease, box-shadow 0.3s ease;
}

/* 关闭按钮 */
.close-btn {
	position: absolute;
	top: 20px;
	right: 20px;
	width: 32px;
	height: 32px;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	border-radius: 50%;
	background: var(--bg-secondary, #f5f5f5);
	color: var(--text-secondary, #666);
	border: none;
	transition: all 0.3s ease;
	z-index: 10;
}

.close-btn:hover {
	background: var(--hover-bg, rgba(0, 0, 0, 0.1));
	color: var(--text-primary, #333);
}

/* 产品头部 */
.detail-header {
	display: flex;
	gap: 20px;
	margin-bottom: 30px;
	padding-bottom: 20px;
	border-bottom: 1px solid var(--border-light, #e8e8e8);
}

.header-icon-wrapper {
	width: 80px;
	height: 80px;
	display: flex;
	align-items: center;
	justify-content: center;
	background: var(--bg-secondary, #f9f9f9);
	border-radius: 16px;
	flex-shrink: 0;
}

.header-icon-img {
	width: 64px;
	height: 64px;
	object-fit: contain;
	border-radius: 12px;
}

.header-info {
	flex: 1;
}

.product-title {
	font-size: 24px;
	font-weight: 600;
	color: var(--text-primary, #333);
	margin: 0 0 15px 0;
	transition: color 0.3s ease;
}

.product-stats {
	display: flex;
	gap: 30px;
}

.stat-item {
	flex: 1;
}

.stat-label {
	font-size: 12px;
	color: var(--text-secondary, #666);
	margin-bottom: 5px;
	transition: color 0.3s ease;
}

.stat-value {
	font-size: 16px;
	font-weight: 600;
	color: var(--text-primary, #333);
	transition: color 0.3s ease;
}

.stat-value.rate {
	font-size: 24px;
	color: var(--primary-color, #0156DC);
}

/* 信息网格 */
.info-grid {
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 20px;
	margin-bottom: 25px;
}

.grid-item {
	background: var(--bg-secondary, #f9f9f9);
	padding: 15px;
	border-radius: 8px;
	transition: background-color 0.3s ease;
}

.grid-label {
	font-size: 12px;
	color: var(--text-secondary, #666);
	margin-bottom: 5px;
	transition: color 0.3s ease;
}

.grid-value {
	font-size: 16px;
	font-weight: 600;
	color: var(--text-primary, #333);
	transition: color 0.3s ease;
}

/* 描述部分 */
.description-section {
	margin-bottom: 25px;
}

.section-title {
	font-size: 16px;
	font-weight: 600;
	color: var(--text-primary, #333);
	margin: 0 0 10px 0;
	transition: color 0.3s ease;
}

.description-text {
	font-size: 14px;
	color: var(--text-secondary, #666);
	line-height: 1.6;
	margin: 0;
	transition: color 0.3s ease;
}

/* 金额输入部分 */
.amount-section {
	margin-bottom: 25px;
}

.amount-input-wrapper {
	position: relative;
	margin-bottom: 10px;
}

.currency-symbol {
	position: absolute;
	left: 20px;
	top: 50%;
	transform: translateY(-50%);
	font-size: 20px;
	font-weight: 600;
	color: var(--text-primary, #333);
	transition: color 0.3s ease;
}

.amount-input {
	width: 100%;
	height: 50px;
	padding: 0 80px 0 50px;
	border: 2px solid var(--border-color, #e0e0e0);
	border-radius: 8px;
	font-size: 16px;
	color: var(--text-primary, #333);
	background: var(--input-bg, #ffffff);
	transition: all 0.3s ease;
	box-sizing: border-box;
}

.amount-input:focus {
	border-color: var(--primary-color, #0156DC);
	outline: none;
	box-shadow: 0 0 0 3px rgba(1, 102, 252, 0.1);
}

.amount-input::placeholder {
	color: var(--text-tertiary, #999);
}

.max-btn {
	position: absolute;
	right: 10px;
	top: 50%;
	transform: translateY(-50%);
	padding: 6px 16px;
	background: var(--primary-color, #0156DC);
	color: white;
	border: none;
	border-radius: 6px;
	font-size: 14px;
	font-weight: 500;
	cursor: pointer;
	transition: all 0.3s ease;
}

.max-btn:hover {
	background: var(--primary-dark);
}

.amount-range {
	display: flex;
	justify-content: space-between;
	font-size: 12px;
	color: var(--text-secondary, #999);
	margin-bottom: 5px;
	transition: color 0.3s ease;
}

.error-message {
	color: #ff4d4f;
	font-size: 13px;
	margin-top: 8px;
	font-weight: 500;
	padding: 8px 12px;
	background: rgba(255, 77, 79, 0.1);
	border-radius: 6px;
	border-left: 3px solid #ff4d4f;
	transition: all 0.3s ease;
}

/* 操作按钮 */
.action-buttons {
	display: flex;
	gap: 15px;
}

.buy-btn,
.cancel-btn {
	flex: 1;
	height: 48px;
	border: none;
	border-radius: 8px;
	font-size: 16px;
	font-weight: 600;
	cursor: pointer;
	transition: all 0.3s ease;
}

.buy-btn {
	background: var(--primary-color, #0156DC);
	color: white;
}

.buy-btn:hover:not(:disabled) {
	background: var(--primary-dark);
	transform: translateY(-1px);
	box-shadow: 0 4px 12px var(--primary-color-20);
}

.buy-btn:disabled {
	background: var(--border-color, #dcdfe6);
	cursor: not-allowed;
	opacity: 0.6;
}

.cancel-btn {
	background: var(--bg-secondary, #f5f5f5);
	color: var(--text-secondary, #666);
	border: 1px solid var(--border-color, #ddd);
}

.cancel-btn:hover {
	background: var(--hover-bg, rgba(0, 0, 0, 0.05));
	border-color: var(--text-secondary, #999);
}

/* 滚动条样式 */
.detail-container::-webkit-scrollbar {
	width: 6px;
}

.detail-container::-webkit-scrollbar-track {
	background: var(--bg-secondary, #f5f5f5);
	border-radius: 3px;
}

.detail-container::-webkit-scrollbar-thumb {
	background: var(--border-color, #dcdfe6);
	border-radius: 3px;
}

.detail-container::-webkit-scrollbar-thumb:hover {
	background: var(--text-tertiary, #999);
}

/* 响应式 */
@media (max-width: 768px) {
	.detail-container {
		padding: 30px 20px;
	}
	
	.detail-header {
		flex-direction: column;
		align-items: center;
		text-align: center;
	}
	
	.info-grid {
		grid-template-columns: 1fr;
	}
}
</style>

